import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { SidebarNavHelper } from '../app-sidebar-nav.service';
import { AppSidebarService } from '../app-sidebar.service';

@Component({
  selector: 'app-sidebar-nav-dropdown, cui-sidebar-nav-dropdown',
  template: `
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle [appHtmlAttr]="item.attributes">
      <i *ngIf="helper.hasIcon(item) && sidebarOpen" [ngClass]="item | appSidebarNavIcon"></i>
      <span class="sidebar-has-tooltip" *ngIf="sidebarOpen === false">
        <span class="sidebar-tooltip">{{ item.name }}</span>
        <i *ngIf="helper.hasIcon(item)" [ngClass]="item | appSidebarNavIcon"></i>
      </span>
      <ng-container *ngIf="sidebarOpen">{{ item.name }}</ng-container>
      <span *ngIf="helper.hasBadge(item)" [ngClass]="item | appSidebarNavBadge">{{ item.badge.text }}</span>
    </a>
    <app-sidebar-nav-items class="nav-dropdown-items" [items]="item.children"> </app-sidebar-nav-items>
  `,
  styles: ['.nav-dropdown-toggle { cursor: pointer; }', '.nav-dropdown-items { display: block; }'],
  providers: [SidebarNavHelper],
})
export class AppSidebarNavDropdownComponent implements OnInit, OnDestroy {
  @Input() item: any;
  sidebarOpen = true;
  private sidebarStatusSubscription: Subscription;

  constructor(
    public helper: SidebarNavHelper,
    private sidebarService: AppSidebarService,
  ) {}

  ngOnInit() {
    this.sidebarStatusSubscription = this.sidebarService.sidebarStatus$.subscribe(status => {
      this.sidebarOpen = status;
    });
  }

  ngOnDestroy() {
    this.sidebarStatusSubscription.unsubscribe();
  }
}
